import {useEffect, useRef, useState, useContext, useCallback} from "react";
import useCanvas from "./useCanvas";

import {createElementImage, initDevice, reportEvent} from "../../../../../utils";
import {EVENT_TRACER, keyswordsBack, keyswordsFront} from "../../../../../constants";
import {Stream} from "../../../utils/helpers/Stream";
import {documentValidator} from "../../../../../services/documentValidator";
import { base64ToBlob, createCanvas, createBase64 } from "../../../utils/canvas";
import {ConfigContext} from "../../../../../context/ConfigContext";
import {onReportEvent, startCamera, startCameraTest, stopCamera} from "../../../utils";
import {useNavigate} from "react-router-dom";
import {analyzeVirtualCamera} from "../../../../liveness/utils";

let worker
let CONFIG
let TIME_TO_CAPTURE_MANUAL = 20
let TIME_TO_CHANGE_MESSAGE_ERROR = 20000

export function isMovil() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
let timer
export default function useCamera({containerAdo, configValue, configLoading, videoRef, canvasRef, guideAdo, textPreviewBack, textPreview, imgBack, takeManual}) {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    const {getFaces} = useCanvas(showStep)
    // const { value: configValue, refetch, loading: configLoading } = useContext(ConfigContext);
    const [loading, setLoading] = useState(true)
    const [cameraIsReady, setCameraIsReady] = useState(false);
    const [isImageValidate, setImageValidate] = useState(false)
    const [typeCapture, setTypeCapture] = useState('')
    const [ocr, setOcr] = useState('')
    const [isCard, setIsCard] = useState('')
    const videoInitRef = useRef(null);
    const finished = useRef(null);
    const initProcess = useRef(null);
    const canvasPreviewRef = useRef(null);
    const canvasCroppedImageRef = useRef(null);
    const timerRef = useRef(0);
    const markRef = useRef(null);
    const takeOneManualPhoto = useRef(true);
    const [capturedImageBack, setCapturedImageBack] = useState(null);
    const [step, setStep] = useState('');
    const [indicatorRotate, setIndicatorRotate] = useState(true);
    const [stepHistory, setStepHistory] = useState([]);
    const [seconds, setSeconds] = useState(0);
    const urlTracer = params.urlTracer
    const processId = params.processId
    const emitReadyCam = params.emitReadyCam || 'false'
    const documentType = params.documentType
    const codeTransaction = params.codeTransaction

    const captured = useRef(false);
    const callbackRef = useRef(null);
    const [detectorStatus, setDetectorStatus] = useState('waiting');
    const isManager = params.isManager || 'false'
    const navigate = useNavigate()

    const [videoDevices, setVideoDevices] = useState([]);
    const [cameraSelectedDefault, setCameraSelectedDefault] = useState('');


    function goToManager() {
        if (isManager === 'true') {
            navigate(-1)
        }
    }

    function rotateBase64Image(base64Image) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;

                const originalCanvas = document.createElement('canvas');
                originalCanvas.width = width;
                originalCanvas.height = height;

                const contextOriginal = originalCanvas.getContext('2d');
                contextOriginal.drawImage(img, 0, 0, originalCanvas.width, originalCanvas.height);

                const rotatedCanvas = document.createElement('canvas');
                rotatedCanvas.width = height;
                rotatedCanvas.height = width;
                const rotatedContext = rotatedCanvas.getContext('2d');
                rotatedContext.translate(0, width);
                rotatedContext.rotate(-Math.PI / 2);
                rotatedContext.drawImage(originalCanvas, 0, 0);

                resolve(rotatedCanvas.toDataURL('image/jpeg'));
            };
            img.onerror = reject;
            img.src = base64Image;
        });
    }

    function onRotateImage() {
        const video = videoRef.current;
        const width = video.videoWidth;
        const height = video.videoHeight;

        const originalCanvas = document.createElement('canvas');
        originalCanvas.width = width;
        originalCanvas.height = height;

        const contextOriginal = originalCanvas.getContext('2d');
        contextOriginal.drawImage(video, 0, 0, originalCanvas.width, originalCanvas.height);

        const rotatedCanvas = document.createElement('canvas');
        rotatedCanvas.width = height;
        rotatedCanvas.height = width;
        const rotatedContext = rotatedCanvas.getContext('2d');
        rotatedContext.translate(0, width);
        rotatedContext.rotate(-Math.PI / 2);
        rotatedContext.drawImage(originalCanvas, 0, 0);

        return rotatedCanvas.toDataURL('image/jpeg');
    }
    async function callbackAutoCapturing({image, status, quality}) {
        if (!captured.current) {
            if (guideAdo.current) {
                guideAdo.current.style.border = `3px solid ${configValue.styles.successColor || '#4CAF50'}`
                if (textPreview.current) {
                    textPreview.current.innerText = configValue?.statusMessages?.SuccesCapture || 'Documento capturado'
                    textPreview.current.style.backgroundColor = '#4CAF50'
                    textPreview.current.style.color = 'white'
                    textPreview.current.style.padding = '10px'
                    textPreview.current.style.borderRadius = '5px'
                    textPreview.current.style.display = 'flex'
                    textPreview.current.style.alignItems = 'center'
                    textPreview.current.style.justifyContent = 'center'
                }
                if (textPreviewBack.current) {
                    textPreviewBack.current.innerText = configValue?.statusMessages?.SuccesCapture || 'Documento capturado'
                    textPreviewBack.current.style.backgroundColor = '#4CAF50'
                    textPreviewBack.current.style.color = 'white'
                    textPreviewBack.current.style.padding = '10px'
                    textPreviewBack.current.style.borderRadius = '5px'
                    textPreviewBack.current.style.display = 'flex'
                    textPreviewBack.current.style.alignItems = 'center'
                    textPreviewBack.current.style.justifyContent = 'center'
                }
            }
            captured.current = true;
            const streamRef = Stream.getInstance()
            streamRef.dropStream()
            clearInterval(timer)
            let imageRotated = image
            try {
                imageRotated = await rotateBase64Image(image);
            } catch (error) {
                console.error('Error rotating image: ', error)
            }
            setTimeout(() => {
                responseToHost(1, imageRotated, imageRotated)
            }, 1000)
        }
    }
    async function onReportEvent(eventType, message = '') {
        if (!urlTracer) return
        try {
            const response = await reportEvent(urlTracer, processId, eventType, message)
        } catch (e) {
            console.log('error report event', e.message)
        }
    }

    function initTimer() {
        timer = setInterval(() => {
            timerRef.current = timerRef.current + 1
            setSeconds(prevState => prevState + 1)
        }, 1000);
    }

    async function startCameraDesktop(cameraType, deviceId) {
        const constraintsDesktop = { video: true };
        if (deviceId) {
            constraintsDesktop.video = { deviceId: { exact: deviceId } };
        }
        try {

            // Si ya hay una cámara activa, detenla
            if (videoRef.current?.srcObject) {
                const tracks = (videoRef.current.srcObject).getTracks();
                tracks.forEach(track => track.stop());
            }

            console.log('startCameraDesktop', constraintsDesktop)

            const stream = await navigator.mediaDevices.getUserMedia(constraintsDesktop);

            console.log('stream', stream);
            if (videoDevices.length === 0) {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const videoInputs = devices.filter(device => device.kind === 'videoinput');
                setVideoDevices(videoInputs);
            }

            videoRef.current.srcObject = stream

            setTimeout(async () => {
                const video = videoRef.current;
                const canvas = canvasRef.current;
                const canvasContext = canvas.getContext('2d');
                canvasContext.imageSmoothingEnabled = true
                video.muted = true;
                onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraOpen, 'Camara del card capture iniciada').catch()

                await setConfigValues()
                initTimer()
                canvas.width = video.videoWidth || 1920;
                canvas.height = video.videoHeight || 1080;
                guideAdo.current.style.transform = 'scale(1)'
                setLoading(false)
                showGuide(true)
            }, 1000)

        } catch (error) {
            console.log('err', error)
            onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureCameraError, error.message).catch()
            setLoading(false)
            responseToHostError(cameraType, error.message)
        }
    }

    function showGuide(show = true) {
        guideAdo.current.style.opacity = show ? '1' : '0'
        imgBack.current.style.opacity = show ? CONFIG?.closeIcon?.show !== true ? '0' : '1' : '0'
        takeManual.current.style.opacity = show ? '1' : '0'
        videoRef.current.style.opacity = show ? '1' : '0'
    }
    function changeGuideToDanger() {
        containerAdo.current.classList.add("danger")
        if (textPreview.current) {
            textPreview.current.innerText = CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto'
            setTimeout(() => {
                containerAdo.current.classList.remove("danger")
                textPreview.current.innerText = CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto'
            }, TIME_TO_CHANGE_MESSAGE_ERROR)
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.innerText = CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto'
            setTimeout(() => {
                containerAdo.current.classList.remove("danger")
                textPreviewBack.current.innerText = CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto'
            }, TIME_TO_CHANGE_MESSAGE_ERROR)
        }
    }
    function rotateBase64Image(base64Image) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;

                const originalCanvas = createCanvas(width, height);
                const contextOriginal = originalCanvas.getContext('2d');
                contextOriginal.drawImage(img, 0, 0, originalCanvas.width, originalCanvas.height);

                const rotatedCanvas = createCanvas(height, width);
                const rotatedContext = rotatedCanvas.getContext('2d');
                rotatedContext.translate(0, width);
                rotatedContext.rotate(-Math.PI / 2);
                rotatedContext.drawImage(originalCanvas, 0, 0);

                resolve(rotatedCanvas.toDataURL('image/jpeg'));
            };
            img.onerror = reject;
            img.src = base64Image;
        });
    }
    function reduceImageQuality(blob, quality) {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = function() {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = img.width;
                canvas.height = img.height;

                ctx.drawImage(img, 0, 0);

                canvas.toBlob((reducedBlob) => {
                    resolve(reducedBlob);
                }, 'image/jpeg', quality);
            };

            img.onerror = function(err) {
                reject(err);
            };

            img.src = URL.createObjectURL(blob);
        });
    }
    async function takeManualPhoto() {
        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureInitCaptureManual, 'Ha entrado en captura manual').catch()
        if (!takeOneManualPhoto.current) {
            return
        }
        takeOneManualPhoto.current = false
        showGuide(false)
        try {
            setLoading(true)
            const isLandscape = window.matchMedia("(orientation: landscape)").matches;
            const canvas = canvasRef.current;
            const imageRotated = onRotateImage();
            if (isLandscape) {
                const base64Image = createBase64(videoRef)
                const imageRotated = await rotateBase64Image(base64Image)
                const blobImage = await base64ToBlob(imageRotated)
                const response = await documentValidator({base64Data: blobImage, urlService: configValue.urlService, isFront, documentType, processId})
                const imageReduced = await reduceImageQuality(blobImage, 0.5)
                setLoading(false)
                if (response.data.quality && response.status === 200) {
                    onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureTakePhoToManual, 'El usuario a tomado una foto manual').catch()
                    responseToHost(isFront === 'true' ? 1 : 2, imageRotated, imageRotated)
                } else {
                    changeGuideToDanger()
                    showGuide(true)
                    takeOneManualPhoto.current = true
                }
            } else {
                const base64Image = createBase64(videoRef)
                const imageRotated = await rotateBase64Image(base64Image)
                const blobImage = await base64ToBlob(imageRotated)
                const response = await documentValidator({base64Data: blobImage, urlService: configValue.urlService, isFront, documentType, processId})
                const imageReduced = await reduceImageQuality(blobImage, 0.5)
                setLoading(false)
                if (response.data.quality && response.status === 200) {
                    onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureTakePhoToManual, 'El usuario a tomado una foto manual').catch()
                    responseToHost(isFront === 'true' ? 1 : 2, imageRotated, imageRotated)
                } else {
                    changeGuideToDanger()
                    showGuide(true)
                    takeOneManualPhoto.current = true
                }
            }
        } catch (e) {
            responseToHostError(isFront === 'true' ? 'Frontal' : 'Trasera', e.message)
        }
    }

    function showStep(message, show= true) {
        if (show) {
            setStepHistory(prevState => [...prevState, message])
            setStep(message)
        }
    }

    const platform = params.platform || 'web'

    function responseToHost(type, image, imageCropped) {
        finished.current = true

        if (videoRef.current) {
            videoRef.current.style.display = 'none'
        }
        if (guideAdo.current) {
            guideAdo.current.style.display = 'none'
        }
        if (textPreview.current) {
            textPreview.current.style.display = 'none'
        }

        if (textPreviewBack.current) {
            textPreviewBack.current.style.display = 'none'
        }
        stopCamera(videoRef)
        if (debug === 'true') {
            const imageref = document.getElementById("imgResult");
            imageref.src = imageCropped
            imageref.style.display = 'block'
            const videoContainerRef = document.getElementById("container-ado-camera");
            if (videoContainerRef) {
                videoContainerRef.style.display = 'none'
            }
            imgBack.current.style.display = 'none'

        }

        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost, 'El servicio emitio al host').catch()
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }));
            goToManager()
            return;
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }));
            goToManager()
            return
        }

        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }))
            goToManager()
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'success',
                step: type === 1 ? 'frontCapture' : 'backCapture',
                data: image,
                cropped: image
            }),
            '*'
        );
        goToManager()
    }
    function responseToHostError(type, message) {
        finished.current = true

        if (videoRef.current) {
            videoRef.current.style.display = 'none'
        }
        if (guideAdo.current) {
            guideAdo.current.style.display = 'none'
        }
        if (textPreview.current) {
            textPreview.current.style.display = 'none'
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.style.display = 'none'
        }
        stopCamera(videoRef)
        onReportEvent(EVENT_TRACER.CARD_CAPTURE.CardCaptureResponseToHost, message).catch()
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }));
            goToManager()
            return;
        }

        if (platform === 'android') {
            window.ResponseAdo.handleEvent(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }));
            goToManager()
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'failure',
                step: message,
                data: ''
            }))
            goToManager()
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'failure',
                step: message,
                data: '',
            }),
            '*'
        );
        goToManager()
    }

    function goBack() {
        setOcr('clicked back')
        if (platform === 'ios') {
            window.webkit.messageHandlers.messageHandlersName.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }));
            goToManager()
            return;
        }

        if (platform === 'android') {
            window.FinishClose.goBack();
            goToManager()
            return
        }
        if (platform === 'react-native') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }))
            goToManager()
            return
        }
        window.parent.postMessage(
            JSON.stringify({
                type: 'success',
                step: 'back',
                data: '',
            }),
            '*'
        );
        goToManager()
    }

    const isFront = params.isFront || 'true'
    const debug = params.debug || 'false'
    const projectName = params.projectName || 'default'

    async function setConfigValues() {
        if (!configValue) console.error('No se encontró la configuración para el proyecto')
        try {
            TIME_TO_CAPTURE_MANUAL = configValue.timeout
            CONFIG = configValue

            if (configValue?.styles?.takePhotoColor) {
                takeManual.current.style.border = `3px solid ${configValue?.styles?.takePhotoColor}`
                const innerDiv = takeManual?.current?.querySelector('.take-manual-inner')
                innerDiv.style.background = configValue?.styles?.takePhotoColor
            }

            if (textPreview.current) {
                textPreview.current.innerText = configValue.messages.messageFront
        }
            if (textPreviewBack.current) {
                textPreviewBack.current.innerText = configValue.messages.messageBack
            }

            if (configValue?.closeIcon && imgBack.current) {
                if (configValue?.closeIcon?.url && isMovil()) {
                    imgBack.current.insertAdjacentHTML("afterbegin", `<img alt="img-back" style="width: 100%" src="${configValue?.closeIcon?.url}"/>`)
                    imgBack.current.style.height = `${configValue?.closeIcon?.size || '30px'}`
                    imgBack.current.style.width = `${configValue?.closeIcon?.size || '30px'}`
                } else {
                    imgBack.current.innerText = "X"
                    imgBack.current.style.fontSize = `${configValue?.closeIcon?.size || '30px'}`
                    imgBack.current.style.color = `${configValue?.closeIcon?.color || 'white'}`
                }
            }

            if (!isMovil()) {
                videoRef.current.style.border = `5px solid ${configValue.styles.guideColor}`
            }
        } catch (e) {
            console.log('error', e)
        }
    }
    useEffect(() => {
        if (projectName && !isMovil() && !configLoading) {
            setConfigValues()
        }
    }, [projectName, configLoading])

    const updateDetectorStatus = useCallback((status, quality = false) => {
        setDetectorStatus(status);

        if (textPreview.current) {
            textPreview.current.innerText = configValue?.statusMessages?.[status] || configValue?.messages?.messageFront;

            if (quality) {
                textPreview.current.style.backgroundColor = 'white';
                textPreview.current.style.color = '#4CAF50';
                textPreview.current.style.display = 'flex';
                textPreview.current.style.alignItems = 'center';
                textPreview.current.style.justifyContent = 'center';
                textPreview.current.style.padding = '10px';
                textPreview.current.style.borderRadius = '5px';
                textPreview.current.style.margin = '10px';

                if (!textPreview.current.querySelector('.check-icon')) {
                    const checkIcon = document.createElement('span');
                    checkIcon.innerHTML = '✓';
                    checkIcon.className = 'check-icon';
                    checkIcon.style.marginLeft = '10px';
                    checkIcon.style.fontSize = '20px';
                    checkIcon.style.fontWeight = 'bold';
                    textPreview.current.appendChild(checkIcon);
                }
            } else {
                textPreview.current.style.backgroundColor = '';
                textPreview.current.style.color = '';
                const checkIcon = textPreview.current.querySelector('.check-icon');
                if (checkIcon) {
                    checkIcon.remove();
                }
            }
        }

        if (textPreviewBack.current) {
            textPreviewBack.current.innerText = configValue?.statusMessages?.[status] || configValue?.messages?.messageBack;

            if (quality) {
                textPreviewBack.current.style.backgroundColor = 'white';
                textPreviewBack.current.style.color = '#4CAF50';
                textPreviewBack.current.style.display = 'flex';
                textPreviewBack.current.style.alignItems = 'center';
                textPreviewBack.current.style.justifyContent = 'center';
                textPreviewBack.current.style.padding = '10px';
                textPreviewBack.current.style.borderRadius = '5px';
                textPreviewBack.current.style.margin = '10px';

                if (!textPreviewBack.current.querySelector('.check-icon')) {
                    const checkIcon = document.createElement('span');
                    checkIcon.innerHTML = '✓';
                    checkIcon.className = 'check-icon';
                    checkIcon.style.marginLeft = '10px';
                    checkIcon.style.fontSize = '20px';
                    checkIcon.style.fontWeight = 'bold';
                    textPreviewBack.current.appendChild(checkIcon);
                }
            } else {
                textPreviewBack.current.style.backgroundColor = '';
                textPreviewBack.current.style.color = '';
                const checkIcon = textPreviewBack.current.querySelector('.check-icon');
                if (checkIcon) {
                    checkIcon.remove();
                }
            }
        }

        // Actualizar UI basado en el status y quality
        if (guideAdo.current) {
            if (quality) {
                guideAdo.current.style.border = `3px solid ${configValue.styles.successColor || '#4CAF50'}`;
                containerAdo.current?.classList.remove("danger");
            } else if (status === 'no_detected' && takeManualCaptured.current === false) {
                guideAdo.current.style.border = '';
                containerAdo.current?.classList.add("danger");
            } else {
                guideAdo.current.style.border = '';
                containerAdo.current?.classList.remove("danger");
            }
        }
    }, [guideAdo, containerAdo, textPreview, textPreviewBack, configValue]);

    function openCamera(cameraType = 1, deviceId) {
        startCameraTest(
            cameraType,
            videoRef,
            canvasRef,
            containerAdo,
            Stream,
            configValue,
            callbackAutoCapturing,
            takeManualCaptured,
            setConfigValues,
            initTimer,
            setLoading,
            responseToHostError,
            showGuide,
            deviceId,
            setVideoDevices,
            setCameraSelectedDefault
        ).catch()
    }
    // Modificar el useEffect donde se configura el stream
    useEffect(() => {
        if (!initProcess.current) {
            initProcess.current = true;
            // refetch();
            if (isFront === 'true' || isFront === 'true/') {
                setTypeCapture('1')
                isMovil()
                ? openCamera(1)
                : startCameraDesktop(1).catch()
            } else {
                setTypeCapture('2')

                isMovil()
                ? openCamera(2)
                : startCameraDesktop(2).catch()
            }
        }
    }, [])

    const takeManualCaptured = useRef(false);
    if (timerRef.current === TIME_TO_CAPTURE_MANUAL && isMovil() && !takeManualCaptured.current) {
        const streamProperties = {
            device: initDevice(),
            modelPath: '/models',
            croppedImage: true,
            urlService: configValue.urlService,
            isFront,
            documentType,
            processId,
            codeTransaction,
        }
        const streamRef = Stream.getInstance(streamProperties)
        streamRef.dropStream()
        takeManual.current.style.display = 'flex'
        takeManualCaptured.current = true

        if (textPreview.current) {
            textPreview.current.innerText = CONFIG?.messages?.messageFrontTimeout || 'Úbica la parte de adelante tu documento y toma la foto'
        }
        if (textPreviewBack.current) {
            textPreviewBack.current.innerText = CONFIG?.messages?.messageBackTimeout || 'Úbica la parte de atrás de tu cédula y toma la foto'
        }
        clearInterval(timer)
    }

    return {
        capturedImageBack,
        cameraIsReady,
        isCard,
        canvasPreviewRef,
        indicatorRotate,
        isImageValidate,
        canvasCroppedImageRef,
        ocr,
        debug,
        step,
        stepHistory,
        typeCapture,
        markRef,
        loading,
        projectName,
        platform,
        configLoading,
        startCameraDesktop,
        isMovil,
        goBack,
        takeManualPhoto,
        isFront,
        emitReadyCam,
        videoDevices,
        configValue,
        cameraSelectedDefault,
        detectorStatus
    }
}
